import { Model, ModelAttributes, model, modelConfig, reference, collection } from "@mixitone/oom";
import { setAccountId } from "./concerns/SetAccountId";
import Account from "./Account";
import AccountUser from "./AccountUser";
import Club from "./Club";
import FundingAppeal from "./FundingAppeal";
import FundingOutreachCommunication from "./FundingOutreachCommunication";
import Funder from "./Funder";
import { Database } from "./database.types";

const config = modelConfig(
  {
    account_id: {
      type: "string",
    },
    amount_awarded_cents: {
      type: "number",
    },
    amount_potential_cents: {
      type: "number",
    },
    amount_requested_cents: {
      type: "number",
    },
    assigned_to_account_user_id: {
      type: "string",
    },
    club_id: {
      type: "string",
    },
    created_at: {
      type: "datetime",
    },
    created_by_account_user_id: {
      type: "string",
    },
    funder_id: {
      type: "string",
    },
    funding_appeal_id: {
      type: "string",
    },
    funding_email_opted_out_at: {
      type: "datetime",
    },
    is_deleted: {
      type: "boolean",
    },
    purpose_label: {
      type: "string",
    },
    status: {
      type: "enum",
      enumType: "" as Database["public"]["Enums"]["funding_outreach_status"],
    },
    updated_at: {
      type: "datetime",
    },
  },
  {},
  {
    account: reference(() => Account as any, "account_id"),
    assigned_to_account_user: reference(() => AccountUser, "assigned_to_account_user_id"),
    club: reference(() => Club as any, "club_id"),
    communications: collection(() => FundingOutreachCommunication as any, "funding_outreach_id"),
    created_by_account_user: reference(() => AccountUser, "created_by_account_user_id"),
    funding_appeal: reference(() => FundingAppeal as any, "funding_appeal_id"),
    funder: reference(() => Funder as any, "funder_id"),
  },
);

interface FundingOutreach extends ModelAttributes<typeof config> {}

@setAccountId
@model("funding_outreach", config)
class FundingOutreach extends Model<typeof config> {}

export default FundingOutreach;
